<template>
  <div class="item-base">
    <div class="header">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="header-content">
        <el-breadcrumb-item :to="'/product'" > 瑞普商城 </el-breadcrumb-item>
        <el-breadcrumb-item ><a @click="handleBack"> 产品列表 </a></el-breadcrumb-item>
        <el-breadcrumb-item> 产品详情 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <rl-img :src="ListData.photoUrl" width="500px" height="500px" border="4px" />
      <div class="img-info">
        <div class="info-name">
          <span v-if="ListData.name">{{ListData.name}}</span>
          <span v-else>Name</span>
        </div>
        <div class="info-list">
            <el-form label-position="left" >
              <el-form-item v-for="item in ListData.labelList" :label="item.name" :key="item.id" label-width="80px" >
                <span v-for="j in item.tagList">{{ j.name }}  </span>
              </el-form-item>
            </el-form>
        </div>
      </div>
    </div>
    <div class="des">
      <h3>产品描述</h3>
      <br>
      <div v-html="ListData.productIntroduce" />
    </div>

  </div>
</template>

<script>
import RlImg from "@/components/img/img";
export default {
  name: "GoodsDetail",
  components: {RlImg},
  data(){
    return{
      ListData:{}
    }
  },
  created() {
    this.GetData(this.$route.params.id)
  },
  methods:{
    handleBack(){
      this.$router.go('-1')
    },
    GetData(id){
      this.$axios.get('/api/productInfo/getById',{params:{
        id :id
        }}).then(res=>{
        console.log(res);
        this.ListData=res.data.data
      })
    }
  }
}
</script>

<style lang="less" scoped>
.item-base{
  .header{
    height: 40px;
    background: var(--bg-color);
    padding-top: 16px;
    padding-left: 12.7vw;

  }
  .content{
    padding-top: 40px;
    width: 74.5vw;
    margin: 0 auto;
    display: flex;
    .img-info{
      width: 620px;
      height: 60px;
      border-bottom: 1px solid;
      margin-left: 160px;
      padding-top: 15px;
      .info-name{
        span{
          height: 24px;
          font-size: 24px;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          font-weight: bold;
          color: #333333;
          line-height: 36px;
        }
      }
      .info-list{
        padding: 10px 0;
      }
    }
  }
  .des{
    width: 74.5vw;
    margin: 0 auto;
    padding: 20px 0;
  }
}

</style>